import React, {useState} from "react";
const styleworkheight = {
        height: "70px"
    }
    
    const stylequestheight = {
        height: "70px",
        marginBottom: "50px",
        marginLeft:"25px",
        marginRight:"40px",
    }
    
    const stylequestline = {
        height: "2px",
        width: "67%",
        padding: "0",
        marginTop: "35px",
        marginLeft: "50px"
    }
export default function Faq() {
    const [answer, setAnswer] = useState(false)
    const Answer1 = () => {
        if (answer === false) {
            document.getElementById("answer1").style.display = "block"
            document.getElementById("questpic1").src = "../images/x.png"
            setAnswer(true)
        }
        else {
            document.getElementById("answer1").style.display = "none"
            document.getElementById("questpic1").src = "../images/+.png"
            setAnswer(false)
        }
    }
    const Answer2 = () => {
        if (answer === false) {
            document.getElementById("answer2").style.display = "block"
            document.getElementById("questpic2").src = "../images/x.png"
            setAnswer(true)
        }
        else {
            document.getElementById("answer2").style.display = "none"
            document.getElementById("questpic2").src = "../images/+.png"
            setAnswer(false)
        }
    }
    const Answer3 = () => {
        if (answer === false) {
            document.getElementById("answer3").style.display = "block"
            document.getElementById("questpic3").src = "../images/x.png"
            setAnswer(true)
        }
        else {
            document.getElementById("answer3").style.display = "none"
            document.getElementById("questpic3").src = "../images/+.png"
            setAnswer(false)
        }
    }
    const Answer4 = () => {
        if (answer === false) {
            document.getElementById("answer4").style.display = "block"
            document.getElementById("questpic4").src = "../images/x.png"
            setAnswer(true)
        }
        else {
            document.getElementById("answer4").style.display = "none"
            document.getElementById("questpic4").src = "../images/+.png"
            setAnswer(false)
        }
    }
    const Answer5 = () => {
        if (answer === false) {
            document.getElementById("answer5").style.display = "block"
            document.getElementById("questpic5").src = "../images/x.png"
            setAnswer(true)
        }
        else {
            document.getElementById("answer5").style.display = "none"
            document.getElementById("questpic5").src = "../images/+.png"
            setAnswer(false)
        }
    }
    return (
        <>
            <div id="faqs_"></div>
            <div id='linetop4'></div>
        <div id='bankruptcy' id="faqs">
            <div className="row" style={stylequestheight}>
                <div className="column-2" id='bankruptcytitle' style={styleworkheight}>Вопрос-ответ </div>
                <div className="column-2" id="line" style={stylequestline}></div>
            </div>
            <div className="question">
                Банкротство – это дорого? Нет!
                <img onClick={Answer1} align="right" src="../images/+.png" id="questpic1"/>
            </div>
            <div id="answer1">В договоре мы установим фиксированную цену за сбор документов, консультации и участие в суде на всех стадиях банкротства. Платите ежемесячно небольшую сумму зафиксированную в договоре оказания квалифицированной юридической помощи</div>
             <div className="question">
                Банкротство – это дорого? Нет!
                <img onClick={Answer2} align="right" src="../images/+.png" id="questpic2"/>
            </div>
            <div id="answer2">В договоре мы установим фиксированную цену за сбор документов, консультации и участие в суде на всех стадиях банкротства. Платите ежемесячно небольшую сумму зафиксированную в договоре оказания квалифицированной юридической помощи</div>
                <div className="question">
                Банкротство – это дорого? Нет!
                <img onClick={Answer3} align="right" src="../images/+.png" id="questpic3"/>
            </div>
            <div id="answer3">В договоре мы установим фиксированную цену за сбор документов, консультации и участие в суде на всех стадиях банкротства. Платите ежемесячно небольшую сумму зафиксированную в договоре оказания квалифицированной юридической помощи</div>
                <div className="question">
                Банкротство – это дорого? Нет!
                <img onClick={Answer4} align="right" src="../images/+.png" id="questpic4"/>
            </div>
            <div id="answer4">В договоре мы установим фиксированную цену за сбор документов, консультации и участие в суде на всех стадиях банкротства. Платите ежемесячно небольшую сумму зафиксированную в договоре оказания квалифицированной юридической помощи</div>
             <div className="question">
                Банкротство – это дорого? Нет!
                <img onClick={Answer5} align="right" src="../images/+.png" id="questpic5"/>
            </div>
            <div id="answer5">В договоре мы установим фиксированную цену за сбор документов, консультации и участие в суде на всех стадиях банкротства. Платите ежемесячно небольшую сумму зафиксированную в договоре оказания квалифицированной юридической помощи</div>
        </div>
        <div id='linebottom2'></div>
            </>
    )
}